<template>
  <div id="offersSlider" class="offers-slider">
    <a
        v-for="(banner, i) in gallery_banners"
        :key="i"
        :href="banner.link"
        :title="banner.title"
        class="offers-slider__link"
    >
      <picture>
        <!-- lazysizes‐friendly WebP source -->
        <source
            v-bind:data-srcset="banner.image.webp"
            data-sizes="auto"
            media="(max-width: 767px)"
            type="image/webp"
        />
        <img
            :alt="banner.title"
            width="1200"
            height="600"
            class="offers-slider__img lazyload"
            :src="i === 0 ? banner.image.source : undefined"
            :data-src="i !== 0 ? banner.image.source : undefined"
            :loading="i === 0 ? 'eager' : 'lazy'"
        />
      </picture>
    </a>
  </div>
</template>

<script>
export default {
  name:  'BannerGallery',
  props: [
      'gallery_banners'
  ]
}

</script>

<style scoped>
.offers-slider {
  width: 100%;
  background: #f5f5f5;
  overflow: hidden;
}

.offers-slider__link,
.offers-slider__link picture,
.offers-slider__img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
